import {
    ProfileVerifyAlertContainerStyled,
    ProfileVerifyAlertDescriptionStyled,
    ProfileVerifyAlertIconStyled,
    ProfileVerifyAlertWrapperStyled
} from './styled/ProfileVerifyAlertStyled';
import { Button } from 'react-bootstrap';
import { BinIcon } from "../../../../components/icon/Icon";
import { useResponsive } from "../../../../components/responsive";
import { RouterPaths } from "../../../../app/appConstants";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import { useCallback } from "react";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";
import appHistory from "../../../../app/appHistory";
import classNames from "classnames";

export const ProfileVerifyAlert = ({className, handleVerifyButtonClick, show}) => {
    const {getLangPath} = useLangContext();
    const {isSmallMaxWidth} = useResponsive();
    const {handleGTMClick} = useGTMEvent({module: 'Header'});

    const handleButtonClick = useCallback(() => {
        appHistory.push(RouterPaths.verify);
        handleGTMClick({button: 'Verify'});
    }, [handleGTMClick]);

    return show && (
        <ProfileVerifyAlertWrapperStyled className={classNames("profile-verify-alert__wrapper", className)}>
            <ProfileVerifyAlertContainerStyled>
                <ProfileVerifyAlertIconStyled>
                    <BinIcon name="IcCheckMarkShield" style={{fontSize: isSmallMaxWidth ? '16px' : '24px'}}/>
                </ProfileVerifyAlertIconStyled>
                <ProfileVerifyAlertDescriptionStyled>
                    {getLangPath('deposit.verify_identity')}
                </ProfileVerifyAlertDescriptionStyled>
            </ProfileVerifyAlertContainerStyled>
            <div className="d-flex justify-content-end w-100 mt-2">
                <Button variant="outline-primary" onClick={handleVerifyButtonClick || handleButtonClick}>
                    {getLangPath('deposit.verify_button')}
                    <BinIcon name="IcArrowRight" className="ms-2" style={{fill: 'var(--color-white)'}}/>
                </Button>
            </div>
        </ProfileVerifyAlertWrapperStyled>
    );
};